var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dm-flex-row"},[_c('ejs-splitbutton',{attrs:{"items":_vm.options,"content":_vm.text,"@click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }